/**
 * Puzzle Builder - TypeScript Entry Point
 *
 * This is the main entry point for the TypeScript-based puzzle builder application.
 * It initializes the application and exposes the legacy facade for backward compatibility.
 *
 * The application exposes TypeScript classes on window.PuzzleBuilder for gradual migration:
 * - Core classes: AppState, Cell, Grid, Puzzle, HistoryManager, Settings
 * - Event handlers: CellEvents, domToCellId, cellIdToDom
 * - UI components: MainMenu, SolutionMenu, ClueMenu
 */

import { exposeLegacyFacade } from './legacy/facade';

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Expose legacy facade for backward compatibility with PHP templates
    exposeLegacyFacade();
});

// ============================================================================
// Core Classes Export
// ============================================================================

export { Cell, Grid, Puzzle, HistoryManager, Settings, Image } from './core';
export type {
    MaskImage,
    PuzzleColors,
    PuzzleConfig,
    CluesCollection,
    SettingsConfig,
    ImageConfig,
} from './core';

// ============================================================================
// State Management Export
// ============================================================================

export { AppState, appState } from './state/AppState';

// ============================================================================
// Event Handlers Export
// ============================================================================

export { CellEvents, domToCellId, cellIdToDom } from './events/CellEvents';

// ============================================================================
// UI Components Export
// ============================================================================

export { MainMenu, SolutionMenu, ClueMenu } from './ui';

// ============================================================================
// Legacy Facade Functions
// ============================================================================

export {
    initPuzzleBuilder,
    initPuzzleSolver,
    passwordStrength,
    checkPassword,
    showOrHide,
    selectAllCheckboxes,
    searchExpression,
} from './legacy/facade';
